<nb-card status="primary" accent="info" >
  <nb-card-body class="container ">
    <br><br>
   <fieldset class="border p-2">
     <legend></legend>
     <div class="row ">
       <div class="col-3 ">

         <div class="row ml-5">

         </div>
         <br>
         <div class="row ml-5">
         </div>         <img  alt=""   src="assets/logos/irving-fund-logo.png" width="80px" height="auto"/>

       </div>

       <div class="col-1 "></div>
       <div class="col-8">

         <div class="row p-2" *ngIf="name">
           <div class="col-12">
             <fa-icon size="1x" [icon]="info" class="m-0"></fa-icon>&nbsp; <strong>{{name}}</strong>
           </div>
         </div>
         <div class="row p-2" *ngIf="mobile">
           <div class="col-12">
             <fa-icon size="1x" [icon]="mobileIcon" class="m-0"></fa-icon>&nbsp;
           </div>
         </div>
         <div class="row p-2" *ngIf="email">
           <div class="col-12 ">
             <fa-icon size="1x" [icon]="mail" class="m-0"></fa-icon>&nbsp;{{email}}
           </div>
         </div>


       </div>

     </div>

   </fieldset>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton hero status="primary" (click)="dismiss()">Close</button>
  </nb-card-footer>
</nb-card>

